import { useContext } from 'react';
import { GlobalContext } from '@store/global-state';

export const useFeatureFlags = () => {
  const { setFeatureFlags } = useContext(GlobalContext);

  const getFeatureFlags = () => {
    setFeatureFlags({ apple: false, google: false });
  };

  return { getFeatureFlags, loadingFeatureFlags: false, dataFeatureFlags: null };
};
